<template lang="pug">
.v-field-range-slider.field-range-slider(:class="{'field-range-slider--disabled': field.disabled || disabled}")
	label.field-range-slide__field-label.field-label(v-if="field.label")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	.field-range-slider__bar
		template(v-if="field.singleHandle")
			.field-range-slider__text-inputs(@click="focusInputMax" @keydown.enter="onEnter")
				.field-range-slider__buffers
					.field-range-slider__buffer(ref="bufferMax") {{computedTextLocalValueMax}}
				input.field-range-slider__text-input(v-if="mask"
						ref="input-max"
						:value="textLocalValueMax"
						v-imask="mask"
						:disabled="computedDisabled"
						type="text"
						inputmode="numeric"
						:style="{'width': maxInputWidth}"
						@accept="onAcceptMaskMax")
				//- .field-range-slider__unit(v-html="displayUnit")
				.field-range-slider__select.js-select-dropdown(v-if="field.options && field.options.length && localValueSelectText"
						:class="{'field-range-slider__select--opened': selectOpened}")
					.field-range-slider__select-bar(@click.stop="selectOpened = !selectOpened")
						.field-range-slider__select-bar-text {{localValueSelectText ? localValueSelectText : field.unit}}
						v-svg-icon.field-range-slider__select-bar-icon(icon="select-bar-icon")
					.field-range-slider__select-dd
						template(v-for="(option, optionIndex) in field.options" :key="optionIndex")
							.field-range-slider__select-dd-item.flc(@click.stop="selectHandler(option)"
									:class="{'field-range-slider__select-dd-item--active': option.value === localValueSelect}")
								.field-range-slider__select-dd-item-text {{option.text}}
								v-svg-icon.field-range-slider__select-dd-item-icon(v-if="option.value === localValueSelect" icon="select-bar-icon-ok")
		template(v-else)
			.field-range-slider__text-inputs
				.field-range-slider__buffers
					.field-range-slider__buffer(ref="bufferMin") {{computedTextLocalValueMin}}
					.field-range-slider__text-inputs-separator
					.field-range-slider__buffer(ref="bufferMax") {{computedTextLocalValueMax}}
				input.field-range-slider__text-input(v-if="mask"
						ref="input-min"
						:value="textLocalValueMin"
						v-imask="mask"
						:disabled="computedDisabled"
						type="text"
						inputmode="numeric"
						:style="{'width': minInputWidth}"
						@accept="onAcceptMaskMin")
				.field-range-slider__text-inputs-separator
				input.field-range-slider__text-input(v-if="mask"
						ref="input-max"
						:value="textLocalValueMax"
						v-imask="mask"
						:disabled="computedDisabled"
						type="text"
						inputmode="numeric"
						:style="{'width': maxInputWidth}"
						@accept="onAcceptMaskMax")
				//- .field-range-slider__unit(v-html="field.options && field.options.length && localValueSelectText ? localValueSelectText : field.unit")

		.field-range-slider__input-wraps(v-if="!field.withoutRange")
			.field-range-slider__visual-handles
				.field-range-slider__visual-handle(v-if="!field.singleHandle" :style="{'left': hanleMinLeft + '%'}")
					v-svg-icon.field-range-slider__visual-handle-icon(icon="slider")
				.field-range-slider__visual-handle(:style="{'left': handleMaxLeft + '%'}")
					v-svg-icon.field-range-slider__visual-handle-icon(icon="slider")
			.field-range-slider__input-wrap.field-range-slider__input-wrap--left(v-if="!field.singleHandle")
				input.field-range-slider__input.field-range-slider__input--left(ref="leftInput"
						:disabled="computedDisabled"
						type="range"
						@change="removeFocus"
						:min="field.min || 0"
						:max="field.max"
						:step="field.precision || 1"
						v-model="localValueMin"
						@input="handleInputSliderMin"
						@mouseup="emitUpdate"
						@touchend.prevent="emitUpdate")
			.field-range-slider__slider-track(:style="{'left': (hanleMinLeft + '%') || 0, 'right': 100 - handleMaxLeft + '%'}")
			.field-range-slider__input-wrap.field-range-slider__input-wrap--right
				input.field-range-slider__input.field-range-slider__input--right(ref="rightInput"
						:disabled="computedDisabled"
						@change="removeFocus"
						type="range"
						:min="field.min || 0"
						:max="field.max"
						:step="field.precision || 1"
						v-model="localValueMax"
						@input="handleInputSliderMax"
						@mouseup="emitUpdate"
						@touchend.prevent="emitUpdate")
</template>

<script>
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';

export default {
	mixins: [
		formattingMixin
	],

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: Object,
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			formatter: new Intl.NumberFormat('fr-FR'),
			localValue: null,
			rulerWidth: 0,
			inputValue: null,
			localValueMin: null,
			localValueMax: null,
			localValueSelect: null,
			localValueSelectText: null,
			minGap: 1,
			mask: {
				"lazy": false,
				"mask": Number,
				"signed": false,
				"min": this.field.min,
				"max": this.field.max,
				"thousandsSeparator": " "
			},
			inputValueMax: null,
			minInputWidth: 0,
			maxInputWidth: 0,
			checkDoubleValueMinTimoutID: null,
			checkDoubleValueMaxTimoutID: null,
			textLocalValueMin: null,
			textLocalValueMax: null,
			loading: false,
			selectOpened: false,
			savedValue: null,
			unmaskedValueMin: null,
			unmaskedValueMax: null,
			maskValue: 0,
			handleInputMaskTimeoutId: null,
			handleInputMaskTimer: 16,
			disabledState: false,
			onAcceptMaskMinTimeoutId: null,
			onAcceptMaskMaxTimeoutId: null,
			onChangeTextLocalValueMinTimeoutId: null,
			onChangeTextLocalValueMaxTimeoutId: null
		};
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				this.updateLocalValue();
			}
		},
	},

	created() {
		this.minGap = this.field.precision >= 1 ? this.field.precision : 1;
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	mounted() {
		this.updateLocalValue();
		setTimeout(() => {
			this.$nextTick(() => {
				this.textLocalValueMin = this.localValueMin;
				this.textLocalValueMax = this.localValueMax;
				this.$nextTick(() => {
					this.setMinInputWidth();
					this.setMaxInputWidth();
				});
			});
		});
	},

	computed: {
		hanleMinLeft() {
			return ((this.localValueMin - this.field.min) / (this.field.max - this.field.min)) * 100;
		},

		handleMaxLeft() {
			return ((this.localValueMax - this.field.min) / (this.field.max - this.field.min)) * 100;
		},

		computedTextLocalValueMin() {
			return this.formatter.format(+this.textLocalValueMax);
		},

		computedTextLocalValueMax() {
			return this.formatter.format(+this.textLocalValueMax);
		},

		computedDisabled() {
			return this.disabledState ||
				this.field.disabled ||
				this.disabled ||
				this.field.name === 'LOAN_AMOUNT' ||
				this.field.name === 'FIRST_PAYMENT';
		},

		displayUnit() {
			if (this.field.options && this.field.options.length && this.localValueSelectText) {
				return this.modelValue.selectCurrency ? this.modelValue.selectCurrency : this.localValueSelectText;
			}
			return this.formatUnit(this.field);
		}
	},

	methods: {
		formatUnit(field) {
			if (field.name.toUpperCase() === 'MONTHS') {
				return this.pluralize(this.textLocalValueMax, 'месяц', ['', 'а', 'ев'])
			}
			if (field.unit) {
				return field.unit
			}
		},

		onAcceptMaskMin(e) {
			clearTimeout(this.onAcceptMaskMinTimeoutId);
			this.onAcceptMaskMinTimeoutId = setTimeout(() => {
				this.$nextTick(() => {
					this.$nextTick(() => {
						let formattedDetailValue = e.detail.value.replace(/\s+/g, '');
						if (formattedDetailValue !== '') {
							formattedDetailValue = +formattedDetailValue;
						}
						this.textLocalValueMin = this.localValueMin = formattedDetailValue;
						this.setMinInputWidth();
					});
				});
			});
		},

		onAcceptMaskMax(e) {
			clearTimeout(this.onAcceptMaskMaxTimeoutId);
			this.onAcceptMaskMaxTimeoutId = setTimeout(() => {
				this.$nextTick(() => {
					this.$nextTick(() => {
						let formattedDetailValue = e.detail.value.replace(/\s+/g, '');
						if (formattedDetailValue !== '') {
							formattedDetailValue = +formattedDetailValue;
						}
						this.textLocalValueMax = formattedDetailValue;
						this.setMaxInputWidth();
						this.$nextTick(() => {
							clearTimeout(this.onChangeTextLocalValueMaxTimeoutId);
							this.onChangeTextLocalValueMaxTimeoutId = setTimeout(() => {
								if (this.textLocalValueMax > this.field.max) {
									this.textLocalValueMax = this.field.max;
								}
								this.localValueMax = this.textLocalValueMax;
								this.setMaxInputWidth();
								this.$nextTick(() => {
									this.disabledState = true;
									this.emitUpdate();
								});
							}, 1000);
						});
					});
				});
			});
		},

		onEnter() {
			this.disabledState = true;
			clearTimeout(this.onChangeTextLocalValueMaxTimeoutId);
			clearTimeout(this.onAcceptMaskMaxTimeoutId);
			this.$nextTick(() => {
				this.$nextTick(() => {
					let formattedDetailValue = this.textLocalValueMax;
					if (formattedDetailValue !== '') {
						formattedDetailValue = +formattedDetailValue;
					}
					this.textLocalValueMax = formattedDetailValue;
					this.setMaxInputWidth();
					if (this.textLocalValueMax > this.field.max) {
						this.textLocalValueMax = this.field.max;
					}
					this.localValueMax = this.textLocalValueMax;
					this.$nextTick(() => {
						this.emitUpdate();
					});
				});
			});
		},

		handleBlurTextInputMin(e) {
			if (e.sourceCapabilities) {
				this.disabledState = true;
				clearTimeout(this.handleInputMaskTimeoutId);
				this.handleInputMaskTimeoutId = setTimeout(() => {
					this.disabledState = true;
					this.handleInputSliderMin();
					this.emitUpdate();
				}, this.handleInputMaskTimer);
			}
		},

		handleBlurTextInputMax(e) {
			if (e.sourceCapabilities) {
				this.disabledState = true;
				clearTimeout(this.handleInputMaskTimeoutId);
				this.handleInputMaskTimeoutId = setTimeout(() => {
					this.disabledState = true;
					this.handleInputSliderMax();
					this.emitUpdate();
				}, this.handleInputMaskTimer);
			}
		},

		focusInputMax() {
			this.$refs['input-max'].focus();
		},

		selectHandler(option) {
			this.localValueSelect = option.value;
			this.localValueSelectText = option.text;
			this.selectOpened = false;
			this.emitUpdate();
		},

		setMinInputWidth() {
			if (this.$refs['bufferMin']) {
				this.$nextTick(() => {
					this.minInputWidth = this.innerWidth(this.$refs['bufferMin']) + 3 + 'px';
				});
			}
		},

		setMaxInputWidth() {
			if (this.$refs['bufferMax']) {
				this.$nextTick(() => {
					this.maxInputWidth = this.innerWidth(this.$refs['bufferMax']) + 3 + 'px';
				});
			}
		},

		innerWidth(el, value) {
			if (value === undefined) {
				return el.clientWidth;
			} else {
				el.style.width = value;
			}
		},

		handleInputSliderMin() {
			if (!this.field.singleHandle) {
				if (parseInt(this.localValueMax) - parseInt(this.localValueMin) <= this.minGap) {
					this.localValueMin = parseInt(this.localValueMax) - this.minGap;
				}
			} else {
				this.localValueMin = +this.localValueMin;
			}
			this.textLocalValueMin = this.localValueMin;
			this.$nextTick(() => {
				this.setMinInputWidth();
			});
		},

		handleInputSliderMax() {
			if (!this.field.singleHandle) {
				if (parseInt(this.localValueMax) - parseInt(this.localValueMin) <= this.minGap) {
					this.localValueMax = parseInt(this.localValueMin) + this.minGap;
				}
			} else {
				this.localValueMax = +this.localValueMax;
			}
			this.textLocalValueMax = this.localValueMax;
			this.$nextTick(() => {
				this.setMaxInputWidth();
			});
		},

		updateLocalValue() {
			this.mask = null;
			this.mask = {
				"lazy": false,
				"mask": Number,
				"signed": false,
				"min": this.field.min,
				//"max": this.field.max,
				"thousandsSeparator": " "
			}
			this.localValueMin = this.modelValue.min;
			this.localValueMax = this.modelValue.max;
			this.localValueSelect = this.modelValue.selectValue;
			if (this.field.options && this.field.options.length && this.localValueSelect) {
				this.localValueSelectText = this.field.options.find(item => item.value === this.localValueSelect).text;
			}
			this.textLocalValueMin = null;
			this.textLocalValueMax = null;
			this.textLocalValueMin = this.localValueMin;
			this.textLocalValueMax = this.localValueMax;
			setTimeout(() => {
				this.$nextTick(() => {
					this.$nextTick(() => {
						this.setMinInputWidth();
						this.setMaxInputWidth();
						this.disabledState = false;
					});
				});
			});
		},

		removeFocus() {
			this.$refs['input-max']?.blur();
			this.$refs['input-min']?.blur();
		},

		emitUpdate() {
			this.disabledState = true;
			this.$emit('update:model-value', {
				min: +this.localValueMin,
				max: +this.localValueMax,
				selectValue: this.localValueSelect
			});
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.selectOpened = false;
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.open) {
				e.stopPropagation();
				this.close();
			}
		}
	}
};
</script>
